// Imports for external libraries go here.
/* eslint-disable @nx/enforce-module-boundaries */
import React, { FC } from 'react';

// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
import { MbopOffersProps } from './MbopOffers.types';
import { StyledMbopOffers } from './MbopOffers.styles';
import { OfferCardCarousel } from '@marriott/mi-offers-components';

// Use named rather than default exports.
export const MbopOffers: FC<MbopOffersProps> = props => {
  return (
    <StyledMbopOffers data-testid="luxury-MbopOffers" data-component-name="m-luxury-MbopOffers">
      <OfferCardCarousel {...props} />
    </StyledMbopOffers>
  );
};
